var carousel_product_promotions_loop_slider = $('.complete-the-look-slider');
var $prevButton = $('.complete_the_look__nav--prev');
var $nextButton = $('.complete_the_look__nav--next');
$(carousel_product_promotions_loop_slider).flickity({
        // options
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: false,// advance cells every 3 seconds
        on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_product_promotions_loop_slider).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_product_promotions_loop_slider).flickity('next');
        });
        }
      }
        
});